import React from "react";
import courses from "../../../Images/courses.svg";
import certificate from "../../../Images/certificate.svg";
import chat from "../../../Images/chat.svg";
import quiz from "../../../Images/quizzes.svg";

const Services = () => {
  const services = [
    {
      title: "Courses",
      desc: "with unlimited courses",
      iconBg: "bg-sky-100",
      iconInner: (
        <div className="flex flex-col items-center">
          <img src={courses} alt="courses" />
        </div>
      ),
    },
    {
      title: "Download Certificates",
      desc: "with unlimited courses",
      iconBg: "bg-sky-100",
      iconInner: (
        <div className="flex flex-col items-center">
          <img src={certificate} alt="certificate" />
        </div>
      ),
    },
    {
      title: "Live Chat",
      desc: "with unlimited courses",
      iconBg: "bg-sky-100",
      iconInner: (
        <div className="flex flex-col items-center">
            <img src={chat} alt="chat" />
        </div>
      ),
    },
    {
      title: "Quizzes",
      desc: "with unlimited courses",
      iconBg: "bg-sky-100",
      iconInner: (
        <div className="flex flex-col items-center">
            <img src={quiz} alt="quiz" />   
        </div>
      ),
    },
  ];

  return (
    <section
      id="services"
      className="flex flex-col items-center text-center py-20 px-6 md:px-16 bg-white"
    >
      {/* 🔹 Title */}
      <h2 className="text-4xl font-extrabold mb-4">
        <span className="text-slate-700">Our </span>
        <span className="text-[#F2542D]">Services</span>
      </h2>

      {/* 🔹 Subtitle */}
      <p className="max-w-2xl text-gray-600 text-sm md:text-base leading-relaxed mb-12">
        Explore a wide range of interactive courses, gain real-world skills, and
        unlock certificates designed to boost your professional growth.
      </p>

      {/* 🔹 Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-16 mt-6">
        {services.map((service, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center gap-3"
          >
            {/* Icon */}
            <div
              className={`w-20 h-20 rounded-full flex items-center justify-center ${service.iconBg}`}
            >
              {service.iconInner}
            </div>

            {/* Text */}
            <h3 className="text-xl font-semibold text-zinc-800">
              {service.title}
            </h3>
            <p className="text-neutral-500 text-base">{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
